import React from "react";
/** @jsx jsx */
import { jsx } from "@emotion/core";
import { Radio, Form, Tooltip } from "antd";
import { RadioGroupProps, RadioChangeEvent } from "antd/lib/radio";
import { FormikProps } from "formik";
import globalColors from "../styles/globalColors";

interface Props extends RadioGroupProps, FormikProps<any> {
  options: Array<{ value: string; label: string }>;
  required?: boolean;
  containerStyle?: any;
  label?: string;
  tooltip?: string;
}

const RadioButton: React.FC<Props> = props => {
  const {
    options,
    defaultValue,
    containerStyle,
    label,
    tooltip,
    required,
    name,
    onChange,
    ...rest
  } = props;
  return (
    <div css={containerStyle}>
      {label ? (
        tooltip ? (
          <Tooltip title={tooltip}>
            <label htmlFor={name}>
              {label} {required && <span css={styles.requiredStar}>*</span>}
            </label>
          </Tooltip>
        ) : (
          <label htmlFor={name}>
            {label} {required && <span css={styles.requiredStar}>*</span>}
          </label>
        )
      ) : null}
      <Form.Item>
        <Radio.Group
          defaultValue={defaultValue}
          buttonStyle="solid"
          size="large"
          onChange={
            onChange ||
            ((event: RadioChangeEvent) => {
              props.setFieldValue(name || "", event.target.value);
            })
          }
          css={styles.groupStyle}
          {...rest}
        >
          {options.map(option => {
            return (
              <Radio.Button key={option.value} value={option.value}>
                {option.label}
              </Radio.Button>
            );
          })}
        </Radio.Group>
      </Form.Item>
    </div>
  );
};

const styles = {
  groupStyle: {
    ".ant-radio-button-wrapper:first-of-type": {
      borderTopLeftRadius: 20,
      borderBottomLeftRadius: 20
    },
    ".ant-radio-button-wrapper:last-of-type": {
      borderTopRightRadius: 20,
      borderBottomRightRadius: 20
    }
  },
  requiredStar: {
    color: globalColors.red
  }
};

export default RadioButton;
